/* eslint-disable */

import {
    getCurrentFilterColor,
    getCurrentPodcastColor,
    getCommaSeparatedStringOfRGB,
} from './internal';

export const DARK_THEME = {
    primaryUi01: () => `rgba(41, 43, 46, 1)`,
    primaryUi01Active: () => `rgba(56, 58, 61, 1)`,
    primaryUi02: () => `rgba(26, 27, 29, 1)`,
    primaryUi02Selected: () => `rgba(51, 184, 244, 0.2)`,
    primaryUi02Active: () => `rgba(34, 36, 39, 1)`,
    primaryUi03: () => `rgba(22, 23, 24, 1)`,
    primaryUi04: () => `rgba(22, 23, 24, 1)`,
    primaryUi05: () => `rgba(57, 58, 60, 1)`,
    primaryUi05Selected: () => `rgba(143, 151, 164, 1)`,
    primaryUi06: () => `rgba(48, 51, 55, 1)`,
    primaryIcon01: () => `rgba(51, 184, 244, 1)`,
    primaryIcon01Active: () => `rgba(100, 199, 244, 1)`,
    primaryIcon02: () => `rgba(143, 151, 164, 1)`,
    primaryIcon02Selected: () => `rgba(51, 184, 244, 1)`,
    primaryIcon02Active: () => `rgba(239, 243, 245, 1)`,
    primaryIcon03: () => `rgba(104, 108, 116, 1)`,
    primaryIcon03Active: () => `rgba(51, 184, 244, 1)`,
    primaryText01: () => `rgba(255, 255, 255, 1)`,
    primaryText02: () => `rgba(156, 159, 164, 1)`,
    primaryText02Selected: () => `rgba(51, 184, 244, 1)`,
    primaryField01: () => `rgba(239, 243, 245, 0.1)`,
    primaryField01Active: () => `rgba(251, 251, 252, 0.15)`,
    primaryField02: () => `rgba(251, 251, 252, 0.11)`,
    primaryField02Active: () => `rgba(251, 251, 252, 0.15)`,
    primaryField03: () => `rgba(184, 195, 201, 0.5)`,
    primaryField03Active: () => `rgba(51, 184, 244, 1)`,
    primaryInteractive01: () => `rgba(51, 184, 244, 1)`,
    primaryInteractive01Hover: () => `rgba(80, 208, 241, 1)`,
    primaryInteractive01Active: () => `rgba(138, 233, 255, 1)`,
    primaryInteractive01Disabled: () => `rgba(51, 184, 244, 0.25)`,
    primaryInteractive02: () => `rgba(41, 43, 46, 1)`,
    primaryInteractive02Hover: () => `rgba(51, 184, 244, 0.05)`,
    primaryInteractive02Active: () => `rgba(51, 184, 244, 0.1)`,

    secondaryUi01: () => `rgba(41, 43, 46, 1)`,
    secondaryUi02: () => `rgba(56, 58, 60, 1)`,
    secondaryIcon01: () => `rgba(51, 184, 244, 1)`,
    secondaryIcon02: () => `rgba(104, 108, 116, 1)`,
    secondaryText01: () => `rgba(255, 255, 255, 1)`,
    secondaryText02: () => `rgba(104, 108, 116, 1)`,
    secondaryField01: () => `rgba(255, 255, 255, 0.1)`,
    secondaryField01Active: () => `rgba(251, 251, 252, 0.15)`,
    secondaryInteractive01: () => `rgba(51, 184, 244, 1)`,
    secondaryInteractive01Hover: () => `rgba(100, 199, 244, 1)`,
    secondaryInteractive01Active: () => `rgba(138, 233, 255, 1)`,

    podcastUi01: () => `rgba(41, 43, 46, 1)`,
    podcastUi02: () => `rgba(${getCommaSeparatedStringOfRGB(getCurrentPodcastColor())}, 0.15)`,
    podcastUi03: () => `rgba(${getCommaSeparatedStringOfRGB(getCurrentPodcastColor())}, 0.3)`,
    podcastUi04: () => `rgba(56, 58, 60, 1)`,
    podcastIcon01: () => `rgba(${getCommaSeparatedStringOfRGB(getCurrentPodcastColor())}, 1)`,
    podcastIcon02: () => `rgba(${getCommaSeparatedStringOfRGB(getCurrentPodcastColor())}, 1)`,
    podcastIcon03: () => `rgba(255, 255, 255, 1)`,
    podcastText01: () => `rgba(${getCommaSeparatedStringOfRGB(getCurrentPodcastColor())}, 1)`,
    podcastText02: () => `rgba(${getCommaSeparatedStringOfRGB(getCurrentPodcastColor())}, 1)`,
    podcastInteractive01: () =>
        `rgba(${getCommaSeparatedStringOfRGB(getCurrentPodcastColor())}, 1)`,
    podcastInteractive01Active: () =>
        `rgba(${getCommaSeparatedStringOfRGB(getCurrentPodcastColor())}, 0.8)`,
    podcastInteractive02: () => `rgba(41, 43, 46, 1)`,
    podcastInteractive03: () =>
        `rgba(${getCommaSeparatedStringOfRGB(getCurrentPodcastColor())}, 1)`,
    podcastInteractive03Active: () =>
        `rgba(${getCommaSeparatedStringOfRGB(getCurrentPodcastColor())}, 0.8)`,
    podcastInteractive04: () => `rgba(41, 43, 46, 1)`,
    podcastInteractive05: () => `rgba(104, 108, 116, 1)`,

    filterUi01: () => `rgba(41, 43, 46, 1)`,
    filterUi02: () => `rgba(${getCommaSeparatedStringOfRGB(getCurrentFilterColor())}, 0.15)`,
    filterUi03: () => `rgba(${getCommaSeparatedStringOfRGB(getCurrentFilterColor())}, 0.3)`,
    filterUi04: () => `rgba(56, 58, 60, 1)`,
    filterIcon01: () => `rgba(${getCommaSeparatedStringOfRGB(getCurrentFilterColor())}, 1)`,
    filterIcon02: () => `rgba(${getCommaSeparatedStringOfRGB(getCurrentFilterColor())}, 1)`,
    filterText01: () => `rgba(${getCommaSeparatedStringOfRGB(getCurrentFilterColor())}, 1)`,
    filterText02: () => `rgba(${getCommaSeparatedStringOfRGB(getCurrentFilterColor())}, 1)`,
    filterInteractive01: () => `rgba(${getCommaSeparatedStringOfRGB(getCurrentFilterColor())}, 1)`,
    filterInteractive01Active: () =>
        `rgba(${getCommaSeparatedStringOfRGB(getCurrentFilterColor())}, 0.8)`,
    filterInteractive02: () => `rgba(41, 43, 46, 1)`,
    filterInteractive03: () => `rgba(${getCommaSeparatedStringOfRGB(getCurrentFilterColor())}, 1)`,
    filterInteractive03Active: () =>
        `rgba(${getCommaSeparatedStringOfRGB(getCurrentFilterColor())}, 0.8)`,
    filterInteractive04: () => `rgba(41, 43, 46, 1)`,
    filterInteractive05: () => `rgba(104, 108, 116, 1)`,

    support01: () => `rgba(51, 184, 244, 1)`,
    support02: () => `rgba(120, 213, 73, 1)`,
    support03: () => `rgba(51, 184, 244, 1)`,
    support04: () => `rgba(68, 144, 220, 1)`,
    support05: () => `rgba(244, 62, 55, 1)`,
    support06: () => `rgba(124, 138, 148, 1)`,
    support07: () => `rgba(41, 43, 46, 1)`,
    support08: () => `rgba(235, 157, 79, 1)`,
    support09: () => `rgba(22, 23, 24, 1)`,

    playerBackground: () => `rgba(${getCommaSeparatedStringOfRGB(getCurrentPodcastColor())}, 0.2)`,
    playerHighlight: () => `rgba(${getCommaSeparatedStringOfRGB(getCurrentPodcastColor())}, 1)`,
    playerContrast01: () => `rgba(255, 255, 255, 1)`,
    playerContrast02: () => `rgba(255, 255, 255, 0.5)`,
    playerContrast03: () => `rgba(255, 255, 255, 0.4)`,
    playerContrast04: () => `rgba(255, 255, 255, 0.3)`,
    playerContrast05: () => `rgba(255, 255, 255, 0.2)`,
    playerContrast06: () => `rgba(255, 255, 255, 0.1)`,

    contrast01: () => `rgba(255, 255, 255, 1)`,
    contrast02: () => `rgba(255, 255, 255, 0.7)`,
    contrast03: () => `rgba(255, 255, 255, 0.5)`,
    contrast04: () => `rgba(255, 255, 255, 0.1)`,

    filter01: () => `rgba(223, 81, 76, 1)`,
    filter02: () => `rgba(235, 157, 79, 1)`,
    filter03: () => `rgba(234, 189, 73, 1)`,
    filter04: () => `rgba(127, 191, 95, 1)`,
    filter05: () => `rgba(27, 160, 220, 1)`,
    filter06: () => `rgba(157, 121, 242, 1)`,
    filter07: () => `rgba(210, 77, 122, 1)`,
    filter08: () => `rgba(189, 194, 196, 1)`,

    overlay: () => `rgba(0, 0, 0, 0.5)`,

    gradient01A: () => `rgba(215, 179, 46, 1)`,
    gradient01E: () => `rgba(193, 128, 0, 1)`,
    gradient02A: () => `rgba(57, 147, 170, 1)`,
    gradient02E: () => `rgba(0, 140, 203, 1)`,
    gradient03A: () => `rgba(201, 82, 46, 1)`,
    gradient03E: () => `rgba(184, 46, 60, 1)`,
    gradient04A: () => `rgba(127, 183, 79, 1)`,
    gradient04E: () => `rgba(80, 141, 50, 1)`,
    gradient05A: () => `rgba(188, 78, 123, 1)`,
    gradient05E: () => `rgba(107, 89, 199, 1)`,
};
